function CHOOSE(index, ...args) {
  return args[index];
}

export default CHOOSE;
